import axios from "axios";

const isLocalDev =
  window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
// Same-origin /api works on the preview host and on the live domain (www + apex),
// because the ingress routes /api/* on whichever host serves the app.
// Cross-origin calls break on the live domain (apex->www redirect kills CORS preflights).
const BASE = isLocalDev && process.env.REACT_APP_BACKEND_URL ? process.env.REACT_APP_BACKEND_URL : "";

const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

let refreshPromise = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    if (
      error.response?.status === 401 &&
      !original._retry &&
      !String(original.url || "").includes("/auth/")
    ) {
      original._retry = true;
      try {
        refreshPromise = refreshPromise || api.post("/auth/refresh", {});
        await refreshPromise;
        refreshPromise = null;
        return api(original);
      } catch (e) {
        refreshPromise = null;
      }
    }
    return Promise.reject(error);
  }
);

export const inr = (paise) =>
  `₹${(paise / 100).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export default api;
